// Configuration constants for clients pagination
export const CLIENTS_PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  DEFAULT_SORT_FIELD: 'created_at',
  DEFAULT_SORT_DIRECTION: 'desc' as const,
  MIN_SEARCH_LENGTH: 0,
  DEBOUNCE_DELAY: 300,
} as const;

export const CLIENTS_SORT_OPTIONS = [
  { value: 'first_name', label: 'clients.sort.firstName' },
  { value: 'last_name', label: 'clients.sort.lastName' },
  { value: 'created_at', label: 'clients.sort.createdAt' },
] as const;

export type ClientsSortField = typeof CLIENTS_SORT_OPTIONS[number]['value'];
export type ClientsSortDirection = 'asc' | 'desc';

export interface ClientsPaginationState {
  page: number;
  pageSize: number;
  sortField: ClientsSortField;
  sortDirection: ClientsSortDirection;
  searchTerm: string;
  selectedWorkoutType: string | null;
  showSoonExpire: boolean;
  showUnpaidOnly: boolean;
  showNoSubscriptionsOnly: boolean;
}

export interface ClientsPaginationInfo {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  pageSize: number;
}